// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1FJHa","header":"ReportDetails_header__x_X3S","title":"ReportDetails_title__k_hH6","left":"ReportDetails_left__Fc3ea"};